import { useEffect, useState } from 'react';
import { Alert, AlertTitle, Box, Button, Stack } from '@mui/material';
import api from 'api/client';

const SEEN_KEY = 'fuzzscan_dismissed_announcements';
const readDismissed = () => { try { return JSON.parse(localStorage.getItem(SEEN_KEY)) || []; } catch { return []; } };
const SEVERITY = { info: 'info', success: 'success', warning: 'warning', critical: 'error' };

// Messages an administrator published for this person. Dismissing one hides it on this browser only.
export default function AnnouncementBanner() {
  const [items, setItems] = useState([]);
  const [dismissed, setDismissed] = useState(readDismissed);

  useEffect(() => {
    let alive = true;
    const load = () => api.get('/api/announcements/').then(({ data }) => alive && setItems(Array.isArray(data) ? data : [])).catch(() => {});
    load();
    const timer = window.setInterval(load, 5 * 60 * 1000);
    return () => { alive = false; window.clearInterval(timer); };
  }, []);

  const hide = (id) => {
    const next = [...dismissed, id];
    setDismissed(next);
    try { localStorage.setItem(SEEN_KEY, JSON.stringify(next.slice(-100))); } catch { /* storage unavailable */ }
  };
  const shown = items.filter((a) => !dismissed.includes(a.id));
  if (!shown.length) return null;
  return (
    <Stack gap={1} sx={{ mb: 1.6 }}>
      {shown.map((a) => (
        <Alert key={a.id} severity={SEVERITY[a.level] || 'info'} action={<Button color="inherit" size="small" onClick={() => hide(a.id)}>Dismiss</Button>} sx={{ borderRadius: 2 }}>
          <AlertTitle sx={{ mb: a.summary || a.body ? undefined : 0 }}>{a.title}</AlertTitle>
          {a.summary}
          {a.body && <Box sx={{ mt: 0.5, whiteSpace: 'pre-wrap', opacity: 0.9 }}>{a.body}</Box>}
        </Alert>
      ))}
    </Stack>
  );
}
